var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.count)?_c('tr',[_c('td',{attrs:{"colspan":_vm.colspan}},[_vm._v("No se han encontrado "+_vm._s(_vm.name))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }